'use strict';/* global define */define('modules/custom-forms/states/team_form-builder/index',['require','exports','module','text!./template.html'],function(require,exports,module){'use strict';/**
   * Define the data restriction based on the roles
   *
   * @param {Function} roleCheck - Helper function to verify particular role.
   * @param {Object} ROLES - Definition of the possible roles.
   *
   * @returns {Object}
   */function restricted(roleCheck,ROLES){return roleCheck.promise(ROLES.supervisor,ROLES.wannabe,ROLES.admin,ROLES.hrAdmin);}/**
   * Verify the provided roles
   *
   * @param {Function} roleCheck - Helper function to verify particular role.
   * @param {Object} ROLES - Definition of the possible roles.
   *
   * @returns {Boolean}
   */function menu(roleCheck,ROLES){return roleCheck(ROLES.supervisor,ROLES.wannabe);}var state={url:'/form-builder',views:{'body@app':{template:require('text!./template.html')}},resolve:{restricted:restricted}};module.exports=state;});
